// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"77a82444","339":"b5925128","508":"aa22d75a","570":"12b3c951","640":"a2113225","842":"9a6d99e1"}[chunkId] + ".chunk.js";
};